// extracted by mini-css-extract-plugin
export default {"home":"home_home__2AaT8","sideBar":"home_sideBar__7e+Z3","text":"home_text__7d2Yl","posts":"home_posts__Red5s"};